<template>
  <div style="margin-top: 30px;">
    <h4 style="margin-bottom: 10px;">
      节点任务项设置
    </h4>
    <el-table
      :data="useTableData"
      border
    >
      <el-table-column
        v-for="item in TABLECOLUMN"
        :key="item.prop"
        :prop="item.prop"
        :label="item.label"
        :min-width="item.minWidth"
        :width="item.width"
        :fixed="item.fixed"
      >
        <template slot-scope="{row}">
          <template v-if="item.prop === 'condition'">
            <div
              v-if="MAX_LOCATION_TYPES.includes(row.taskType)"
              style="display: flex;align-items: center;"
            >
              <span style="margin-right: 5px">单任务库位上限</span>
              <el-select
                v-model="row.taskStorehouseMaxB"
                :disabled="isDetail"
                style="width: 100px;margin-right: 10px"
                @change="handleChangeLocationMax($event, row)"
              >
                <el-option
                  label="自定义"
                  value="SELF"
                />
                <el-option
                  label="不限"
                  value="NO_LIMIT"
                />
              </el-select>
              <el-input-number
                v-model="row.taskStorehouseMax"
                step-strictly
                :step="1"
                :min="0"
                :precision="0"
                :controls="false"
                placeholder="请输入"
                :disabled="isDetail"
                @change="handleTaskStorehouseMax($event, row)"
              />
            </div>
            <div v-if="IS_ENABLE.includes(row.taskType)">
              <el-checkbox
                v-model="row.isEnabled"
                label="启用"
                :value="true"
              />
            </div>
            <condition
              v-if="NEED_REVIEW_TYPES.includes(row.taskType)"
              :ref="`${nodeIndex}_${row.taskType}`"
              :task-type="row.taskType"
              :table-data="row.configPreCondition.preConditions"
              @changeConfigRecheck="changeConfigRecheck($event, row)"
            />
          </template>
          <template v-if="item.prop === 'configTimeCondition'">
            <taskGenerated
              ref="taskGeneratedEl"
              :use-id="row.useId"
              :value="row.configTimeCondition"
              @input="handleUpdateTableData($event, 'configTimeCondition')"
            />
          </template>
          <template v-else-if="item.prop === 'allocateType'">
            <el-radio-group
              v-model="row.allocateType"
              :disabled="isDetail"
            >
              <el-radio
                v-for="checkbox in DIS_METHOD_OPTIONS"
                :key="checkbox.label"
                :label="checkbox.value"
                style="margin-bottom: 10px"
              >
                {{ checkbox.label }}
              </el-radio>
            </el-radio-group>
          </template>
          <template v-else-if="item.prop === 'configOperatorType'">
            <operationMode
              ref="opreationModeEl"
              :use-id="row.useId"
              :value="row.configOperatorType"
              :use-table-data="useTableData"
              @input="handleUpdateTableData($event, 'configOperatorType')"
            />
          </template>
          <template v-else-if="item.prop === 'configGroupType'">
            <template
              v-if="row.taskGroupingOptions.length
                && row.configGroupType && row.configGroupType.taskGroupTypes.length"
            >
              <el-checkbox-group
                v-model="row.configGroupType.taskGroupTypes"
                :disabled="isDetail"
              >
                <el-checkbox
                  v-for="checkbox in row.taskGroupingOptions"
                  :key="checkbox.label"
                  :label="checkbox.value"
                >
                  {{ checkbox.label }}
                </el-checkbox>
              </el-checkbox-group>
            </template>
          </template>
          <template v-else-if="item.prop === 'configAuthorityType'">
            <el-form
              ref="formConfigAuthorityType"
              :model="row.configAuthorityType"
              style="height: 100px"
            >
              <el-form-item
                prop="authorityTypes"
                style="margin-bottom: 5px"
                :rules="[
                  {
                    required: true,
                    message: '请选择权限类型',
                    trigger: 'change'
                  }
                ]"
              >
                <el-checkbox-group
                  v-model="row.configAuthorityType.authorityTypes"
                  :disabled="isDetail"
                >
                  <el-checkbox
                    v-for="checkbox in TASK_PER_OPTIONS"
                    :key="checkbox.label"
                    :label="checkbox.value"
                  >
                    {{ checkbox.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-form>
          </template>
          <template v-else-if="item.prop === 'taskExecutionEfficiency'">
            <el-form
              ref="formExecuteMaxTime"
              :model="row"
              style="height: 50px"
              :rules="executeMaxTimeRules"
            >
              <el-form-item
                prop="executeMaxTime"
                class="execute-max-time"
              >
                <prescription
                  :show-lable="false"
                  :disabled="isDetail"
                  :time.sync="row.executeMaxTime"
                  :time-type.sync="row.executeMaxTimeUnit"
                />
              </el-form-item>
            </el-form>
          </template>
          <template v-else-if="item.prop === 'fieldSetting'">
            <fieldSetting
              :use-id="row.useId"
              :task-type="row.taskType"
              :value="row.configTaskField.taskItemFields"
              :node-index="nodeIndex"
              @input="handleUpdateTableData($event, 'configTaskField')"
            />
          </template>
          <template v-else-if="item.prop === 'action'">
            <el-button
              type="text"
              @click="viewTask(row)"
            >
              预览任务项
            </el-button>
            <el-button
              v-if="!isDetail && !row.isForceTask"
              type="text"
              style="margin-left: 20px; margin-top: 5px;"
              @click="handleDelete(row)"
            >
              删 除
            </el-button>
          </template>
          <template v-else>
            {{ row[item.prop] }}
          </template>
        </template>
        <template v-if="item.prop === 'fieldSetting'" slot="header">
          <div>
            任务项字段设置
            <el-tooltip placement="top">
              <div slot="content">
                <div style="font-size: 16px;font-weight: bold;margin-bottom: 5px;">
                  是否显示：
                </div>
                <p style="margin-left: 1em;margin-bottom: 5px;">
                  影响所有页面
                </p>
                <p style="margin-left: 2em;margin-bottom: 5px;">
                  【特例】入库单的新增页，不会显示「分配月台、食品进口品证明材料」字段
                </p>
                <div style="font-size: 16px;font-weight: bold;margin-bottom: 5px;">
                  是否必填：
                </div>
                <p style="margin-left: 1em;margin-bottom: 5px;">
                  只影响到货登记页字段是否必填
                </p>
                <p style="margin-left: 2em;margin-bottom: 5px;">
                  入库单新增、编辑页的是否必填是写死的，即：
                </p>
                <p style="margin-left: 3em;margin-bottom: 5px;">
                  车牌号、司机姓名、司机手机号是选填
                </p>
                <p style="margin-left: 3em;margin-bottom: 5px;">
                  装卸情况必填
                </p>
              </div>
              <i class="el-iconfont el-icon-info" />
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-button
      v-if="!isDetail"
      type="primary"
      style="margin-top: 20px"
      :disabled="forbidAddTask"
      @click="handleAddTask"
    >
      添加任务
    </el-button>
    <add-task ref="addTask" @sure="handleCheckTask" />
    <task-detail ref="taskDetail" />
  </div>
</template>

<script>
import { getTaskByNode } from '@/api/configure/outboundProcess';
import {
  TABLECOLUMN,
  DIS_METHOD_OPTIONS,
  TASK_PER_OPTIONS,
  NODES,
  NODE_TYPE,
  TASK_WORK_GROUP,
  MAX_LOCATION_TYPES,
  NEED_REVIEW_TYPES,
  IS_ENABLE,
  WORK_MODE,
} from './constant';
import condition from '../../components/Condition.vue';
import taskGenerated from '../../components/TaskGenerated.vue';
import operationMode from '../../components/OperationMode.vue';
import prescription from '../../components/Prescription.vue';
import fieldSetting from '../../components/FieldSetting.vue';
import addTask from '../../components/AddTaskDialog.vue';
import taskDetail from '../../components/TaskDetailDialog.vue';

const DEFAULT_NUM = 99999999;
export default {
  emits: ['update:time', 'update:timeType'],
  inject: ['isDetail', 'systemTableData', 'taskAllTableData'],
  components: {
    condition,
    taskGenerated,
    operationMode,
    prescription,
    fieldSetting,
    addTask,
    taskDetail,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    formData: {
      type: Object,
      default: () => {},
    },
    nodeIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      useTableData: [],
      currentNodeForceTask: [],
      TABLECOLUMN,
      DIS_METHOD_OPTIONS,
      TASK_PER_OPTIONS,
      MAX_LOCATION_TYPES,
      NEED_REVIEW_TYPES,
      IS_ENABLE,
      forbidAddTask: false,
      executeMaxTimeRules: {
        executeMaxTime: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value === undefined || value === '') {
                callback(new Error('请填写任务执行时效'));
              } else if (value < 0) {
                callback(new Error('任务执行时效不能小于0'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },
    };
  },
  watch: {
    tableData: {
      immediate: true,
      handler(newVal) {
        const taskAllTableData = this.taskAllTableData();
        this.useTableData = newVal.map((i) => {
          const useI = i;
          useI.useId = Math.random(); // 自定义任务可重复添加，前端自己设置id
          if (useI.taskStorehouseMax === DEFAULT_NUM) {
            useI.taskStorehouseMaxB = 'NO_LIMIT';
          } else {
            useI.taskStorehouseMaxB = 'SELF';
          }
          // 根据原始模板获取其它信息
          const originTask = taskAllTableData.find((o) => o.taskTemplateCode === i.taskTemplateCode);
          if (originTask) { // 当前任务的全量任务分组
            useI.taskGroupingOptions = this.getGroupOptions(originTask.taskGroupTypes);
          }
          return useI;
        });
      },
    },
  },
  mounted() {
    this.getForceTask();
    if ([1, 2].includes(this.nodeIndex)) {
      if (this.formData.openPoint) {
        this.forbidAddTask = false;
      } else {
        this.forbidAddTask = true;
      }
    }
  },
  methods: {
    // 禁用添加任务功能
    disableTask(isUseReservation) {
      if (isUseReservation) {
        this.forbidAddTask = false;
        this.handleCheckTask(this.currentNodeForceTask);
      } else {
        this.forbidAddTask = true;
        this.useTableData = [];
      }
    },
    // 纯获取数据
    getPureTableData() {
      return this.useTableData;
    },
    // 重置下拉数据
    resetTaskOptions() {
      const taskGeneratedEls = this.$refs.taskGeneratedEl || [];
      const opreationModeEls = this.$refs.opreationModeEl || [];
      const allEls = [...taskGeneratedEls, ...opreationModeEls].filter((i) => i);
      allEls.forEach((i) => {
        i.getTaskOptions();
      });
    },
    // 获取强制任务
    async getForceTask() {
      const forceTask = await getTaskByNode({ isForceTask: 1 });
      const currentNodeForceTask = forceTask.filter((i) => i.flowNodeType
        === NODE_TYPE[this.nodeIndex].value);
      this.currentNodeForceTask = currentNodeForceTask;
      // 新增时将强制任务先请求回来
      if (!this.isDetail && !this.$route.query.num) {
        if (([1, 2].includes(this.nodeIndex) && this.formData.openPoint)
          || ![1, 2].includes(this.nodeIndex)) {
          this.handleCheckTask(currentNodeForceTask);
        }
      }
    },
    handleChangeLocationMax(value, { useId }) {
      this.useTableData = this.useTableData.map((i) => {
        const useI = i;
        if (i.useId === useId) {
          if (value === 'NO_LIMIT') {
            useI.taskStorehouseMax = DEFAULT_NUM;
          } else {
            useI.taskStorehouseMax = 0;
          }
        }
        return useI;
      });
    },
    handleTaskStorehouseMax(value, { useId }) {
      this.useTableData = this.useTableData.map((i) => {
        const useI = i;
        if (i.useId === useId) {
          if (Number(value) !== DEFAULT_NUM) {
            useI.taskStorehouseMaxB = 'SELF';
          } else {
            useI.taskStorehouseMaxB = 'NO_LIMIT';
          }
        }
        return useI;
      });
    },
    handleUpdateTableData(newData, keyName) {
      this.useTableData = this.useTableData.map((item) => {
        const useItem = item;
        if (useItem.useId === newData.useId) {
          useItem[keyName] = newData[keyName];
        }
        return useItem;
      });
    },
    async getTableData(stepActive) {
      if (this.useTableData.length) {
        await this.validateTableData(stepActive);
        return this.useTableData;
      }
      return [];
    },
    viewTask(rowData) {
      this.$refs.taskDetail.showDialog(rowData);
    },
    handleDelete({ useId }) {
      const useTableData = this.useTableData.filter((i) => i.useId !== useId);
      // 更新作业方式中自动化数据
      useTableData.map((i) => {
        const useI = i;
        const newTaskTypes = [];
        if (useI.configOperatorType.operatorType === WORK_MODE[2].value) {
          useI.configOperatorType.timeCondition.taskTypes.forEach((n) => {
            if (useTableData.find((m) => m.taskTemplateCode === n)) {
              newTaskTypes.push(n);
            }
          });
          useI.configOperatorType.timeCondition.taskTypes = newTaskTypes;
        }
        return useI;
      });
      this.useTableData = useTableData;
      this.resetTaskOptions();
    },
    handleAddTask() {
      const systemTableData = this.systemTableData();
      // 当前节点不允许重复添加任务, 且不允许添加其它节点任务
      this.$refs.addTask.showDialog(
        [...systemTableData, ...this.useTableData],
        NODE_TYPE[this.nodeIndex].value,
        'INBOUND',
      );
    },
    handleCheckTask(tasks) {
      // console.log(tasks);
      const useTasks = tasks.map((i) => {
        const useI = this.getColumnData();
        useI.useId = Math.random();
        useI.taskTemplateCode = i.taskTemplateCode;
        useI.isSystem = i.isSystem || false;
        useI.taskType = i.taskType;
        useI.isForceTask = i.isForceTask || false; // true是强制，false非强制
        useI.taskName = i.taskTemplateName;
        useI.taskGroupingOptions = this.getGroupOptions(i.taskGroupTypes);
        if (i.fields && i.fields.length) {
          useI.configTaskField.taskItemFields = i.fields.map((n) => ({
            fieldName: n.fieldTitle,
            fieldCode: n.fieldCode,
            isShow: ['carConfirm', 'plateNo'].includes(n.fieldCode),
            isRequire: ['carConfirm', 'plateNo'].includes(n.fieldCode),
          }));
        } else {
          useI.configTaskField.taskItemFields = [];
        }
        return useI;
      });
      this.useTableData.push(...useTasks);
      this.resetTaskOptions();
    },
    getGroupOptions(taskGroupTypes = []) {
      const useTaskGroupTypes = taskGroupTypes.map((i) => i);
      const options = TASK_WORK_GROUP.filter((i) => !!useTaskGroupTypes.find((n) => i.value === n));
      return options;
    },
    validateTableData(stepActive) {
      /* eslint-disable-next-line */
      return new Promise(async (resolve) => {
        const commonPass = this.useTableData.every((i) => {
          const taskGeneratedPass = this.validateTaskGenerated(i.configTimeCondition);
          const taskPermissionPass = this.validateLegth(i.configAuthorityType.authorityTypes);
          const operationModePass = this.validateOperationModePass(i.configOperatorType);
          const taskExPass = this.validateTaskEx(i.executeMaxTime);
          return taskGeneratedPass && taskPermissionPass && taskExPass
            && operationModePass;
        });
        if (commonPass) {
          resolve(commonPass);
        } else {
          this.$message.warning(`请完善“${NODE_TYPE[stepActive].label}”节点数据`);
        }
      });
    },
    validateTaskGenerated(configTimeCondition) {
      const taskGeneratedEls = this.$refs.taskGeneratedEl || [];
      taskGeneratedEls.forEach((i) => {
        i.validate();
      });
      let isPass = false;
      if (configTimeCondition.eventType && configTimeCondition.flowNodeProType) {
        if (configTimeCondition.eventType === NODES[2].value) {
          isPass = !!configTimeCondition.taskTypes.length;
        } else {
          isPass = true;
        }
      }
      return isPass;
    },
    validateLegth(data) {
      const formConfigAuthorityType = this.$refs.formConfigAuthorityType || [];
      formConfigAuthorityType.forEach((i) => {
        i.validate();
      });
      return !!data.length;
    },
    validateTaskEx(executeMaxTime) {
      const formExecuteMaxTimeEls = this.$refs.formExecuteMaxTime || [];
      formExecuteMaxTimeEls.forEach((i) => {
        i.validate();
      });
      return executeMaxTime >= 0;
    },
    validateOperationModePass(configOperatorType) {
      const opreationModeEls = this.$refs.opreationModeEl || [];
      opreationModeEls.forEach((i) => {
        i.validate();
      });
      let isPass = false;
      if (configOperatorType.operatorType === WORK_MODE[2].value) {
        const { timeCondition } = configOperatorType;
        if (timeCondition?.eventType && timeCondition?.flowNodeProType) {
          if (timeCondition.eventType === NODES[2].value) {
            isPass = !!timeCondition?.taskTypes.length;
          } else {
            isPass = true;
          }
        }
      } else {
        isPass = true;
      }
      return isPass;
    },
    changeConfigRecheck(value, { useId }) {
      this.useTableData = this.useTableData.map((i) => {
        const useI = i;
        if (i.useId === useId) {
          useI.configPreCondition.preConditions = value;
        }
        return useI;
      });
    },
    getColumnData() {
      return {
        moduleType: 'OUTBOUND', // 模块（出库，入库）
        flowNodeType: NODE_TYPE[this.nodeIndex].value,
        taskName: '',
        configPreCondition: {
          preConditions: [],
        }, // 满足条件
        taskStorehouseMaxB: 'SELF',
        taskStorehouseMax: '', // 库位上限
        isEnabled: false, // 是否启用
        configTimeCondition: { // 任务何时生成
          eventType: '',
          flowNodeProType: '',
          taskTypes: [],
        },
        allocateType: 'MANUAL', // 分配方式
        configGroupType: { // 任务作业分组
          taskGroupTypes: [],
        },
        configOperatorType: { // 作业方式
          operatorType: WORK_MODE[0].value,
          timeCondition: {
            eventType: '',
            flowNodeProType: '',
            taskTypes: [],
          },
        },
        configAuthorityType: { // 任务权限
          authorityTypes: [],
        },
        executeMaxTime: undefined,
        executeMaxTimeUnit: 'HOURS',
        configTaskField: {
          taskItemFields: [],
        },
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.execute-max-time.is-error {
  ::v-deep .time-type {
    .el-input__inner {
      border-color: #CCCCCC;
    }
  }
}
</style>
